// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CardTransactionInfoAPIModel,
    CardTransactionInfoAPIModelFromJSON,
    CardTransactionInfoAPIModelFromJSONTyped,
    CardTransactionInfoAPIModelToJSON,
    SbpTransactionInfoAPIModel,
    SbpTransactionInfoAPIModelFromJSON,
    SbpTransactionInfoAPIModelFromJSONTyped,
    SbpTransactionInfoAPIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApiTransactionAPIModel
 */
export interface ApiTransactionAPIModel {
    /**
     * 
     * @type {string}
     * @memberof ApiTransactionAPIModel
     */
    cid: string;
    /**
     * 
     * @type {string}
     * @memberof ApiTransactionAPIModel
     */
    uid: string;
    /**
     * 
     * @type {number}
     * @memberof ApiTransactionAPIModel
     */
    transactionId?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiTransactionAPIModel
     */
    accountFrom: number;
    /**
     * 
     * @type {number}
     * @memberof ApiTransactionAPIModel
     */
    accountTo: number;
    /**
     * 
     * @type {number}
     * @memberof ApiTransactionAPIModel
     */
    otherAccount: number;
    /**
     * 
     * @type {number}
     * @memberof ApiTransactionAPIModel
     */
    account: number;
    /**
     * 
     * @type {string}
     * @memberof ApiTransactionAPIModel
     */
    amount: string;
    /**
     * 
     * @type {Date}
     * @memberof ApiTransactionAPIModel
     */
    timestamp: Date;
    /**
     * 
     * @type {string}
     * @memberof ApiTransactionAPIModel
     */
    status: ApiTransactionAPIModelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiTransactionAPIModel
     */
    flowDirection: ApiTransactionAPIModelFlowDirectionEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiTransactionAPIModel
     */
    transactionType: ApiTransactionAPIModelTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiTransactionAPIModel
     */
    accountFromFee: string;
    /**
     * 
     * @type {string}
     * @memberof ApiTransactionAPIModel
     */
    accountToFee: string;
    /**
     * 
     * @type {string}
     * @memberof ApiTransactionAPIModel
     */
    comment?: string;
    /**
     * 
     * @type {SbpTransactionInfoAPIModel}
     * @memberof ApiTransactionAPIModel
     */
    sbpInfo?: SbpTransactionInfoAPIModel;
    /**
     * 
     * @type {CardTransactionInfoAPIModel}
     * @memberof ApiTransactionAPIModel
     */
    cardInfo?: CardTransactionInfoAPIModel;
}

/**
* @export
* @enum {string}
*/
export enum ApiTransactionAPIModelStatusEnum {
    Initiated = 'Initiated',
    Prepared = 'Prepared',
    InProgress = 'InProgress',
    Finished = 'Finished',
    Cancelled = 'Cancelled',
    Failed = 'Failed',
    TakenInNotSent = 'TakenInNotSent',
    Frozen = 'Frozen',
    TakenOut = 'TakenOut',
    Unknown = 'Unknown'
}/**
* @export
* @enum {string}
*/
export enum ApiTransactionAPIModelFlowDirectionEnum {
    Debit = 'Debit',
    Credit = 'Credit'
}/**
* @export
* @enum {string}
*/
export enum ApiTransactionAPIModelTransactionTypeEnum {
    Deposit = 'Deposit',
    Withdraw = 'Withdraw',
    Transfer = 'Transfer',
    Payment = 'Payment',
    Unknown = 'Unknown'
}

export function ApiTransactionAPIModelFromJSON(json: any): ApiTransactionAPIModel {
    return ApiTransactionAPIModelFromJSONTyped(json, false);
}

export function ApiTransactionAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiTransactionAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cid': json['cid'],
        'uid': json['uid'],
        'transactionId': !exists(json, 'transactionId') ? undefined : json['transactionId'],
        'accountFrom': json['accountFrom'],
        'accountTo': json['accountTo'],
        'otherAccount': json['otherAccount'],
        'account': json['account'],
        'amount': json['amount'],
        'timestamp': (new Date(json['timestamp'])),
        'status': json['status'],
        'flowDirection': json['flowDirection'],
        'transactionType': json['transactionType'],
        'accountFromFee': json['accountFromFee'],
        'accountToFee': json['accountToFee'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'sbpInfo': !exists(json, 'sbpInfo') ? undefined : SbpTransactionInfoAPIModelFromJSON(json['sbpInfo']),
        'cardInfo': !exists(json, 'cardInfo') ? undefined : CardTransactionInfoAPIModelFromJSON(json['cardInfo']),
    };
}

export function ApiTransactionAPIModelToJSON(value?: ApiTransactionAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cid': value.cid,
        'uid': value.uid,
        'transactionId': value.transactionId,
        'accountFrom': value.accountFrom,
        'accountTo': value.accountTo,
        'otherAccount': value.otherAccount,
        'account': value.account,
        'amount': value.amount,
        'timestamp': (value.timestamp.toISOString()),
        'status': value.status,
        'flowDirection': value.flowDirection,
        'transactionType': value.transactionType,
        'accountFromFee': value.accountFromFee,
        'accountToFee': value.accountToFee,
        'comment': value.comment,
        'sbpInfo': SbpTransactionInfoAPIModelToJSON(value.sbpInfo),
        'cardInfo': CardTransactionInfoAPIModelToJSON(value.cardInfo),
    };
}


